import React from 'react';
import styles from './TypeBadge.module.css';

const TYPE_CONFIG = {
  'free-to-keep':      { label: 'Free to Keep',     className: 'keepBadge' },
  'free-weekend':      { label: 'Free Weekend',      className: 'weekendBadge' },
  'permanently-free':  { label: 'Permanently Free',  className: 'permanentBadge' },
};

function TypeBadge({ type }) {
  const config = TYPE_CONFIG[type];
  if (!config) return null;

  return (
    <span className={`${styles.badge} ${styles[config.className]}`}>
      {config.label}
    </span>
  );
}

export default TypeBadge;
